export const SEARCH_RANKING_URL = {
  RANKINGS: "/search/apis/search/unrestricted/rankings",
  RANKING_GROUPS: "/hospital/apis/search/unrestricted/ranking-groups",
} as const
